module.exports = __webpack_public_path__ + "img/page_unavailable.bc5b7aad.png";